import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/devop.com-logo.png';

function ComingSoon() {
  return (
    <div style={{
      margin: 0, padding: 0, width: '100%', minHeight: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Arial, sans-serif', backgroundColor: '#f4f7f9', color: '#333'
    }}>
      <div style={{
        width: '90%', maxWidth: '600px', padding: '40px 20px',
        background: '#ffffff', boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
        borderRadius: '8px', textAlign: 'center', borderTop: '5px solid #00AEEF'
      }}>
        <div style={{ marginBottom: '10px' }}>
          <Link to="/"><img src={logo} alt="DDevOps Logo" width="250" /></Link>
        </div>

        <div style={{ height: '2px', width: '50px', background: '#00AEEF', margin: '20px auto' }}></div>

        <h1 style={{ fontSize: '32px', margin: '10px 0', color: '#222' }}>Forum Coming Soon</h1>

        <p style={{ fontSize: '18px', lineHeight: '1.6', color: '#666', marginBottom: '30px' }}>
          Our community forum is currently under maintenance and will be launched soon. Stay tuned for expert DevOps discussions and support.
        </p>

        <div style={{ fontSize: '14px', color: '#888' }}>
          Questions? Contact us at: <br />
          <a href="mailto:support@ddevops.com" style={{ color: '#0056b3', textDecoration: 'none' }}>
            support@ddevops.com
          </a>
        </div>

        <div className="mt-4">
          <Link to="/" className="btn btn-info text-white px-4">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
